import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { ProfissionalComissoes } from "app/types/comissoes/Profissionais";

const estiloIncluirEditarAbaProfissionais = require("./inclusao-edicao-aba-profissionais.module.scss").default;
const estiloBotoes = require("./../../../../estilos/botoes.module.scss").default;

export type DadosInclusaoEdicaoAbaProfissionais = {
  listaProfissionaisTipo: {[codigo: number]: string}
  profissionaisSelecionados: ProfissionalComissoes[]
}

export type InclusaoEdicaoAbaProfissionaisProps = {
  listarProfissionais: ProfissionalComissoes[];
  colorBackgroundSelecionadaInclusaoEdicao: string;
  colorTextoSelecionadaInclusaoEdicao: string; 
  onAlteradoDadosInclusaoEdicaoAbaProfissionais: (dados: DadosInclusaoEdicaoAbaProfissionais) => void;
  onAplicar: (listarProfissionais: ProfissionalComissoes[]) => void;
  onInserir: (semProfissionaisAdiconados: boolean) => void;
  onExcluir: (listarProfissionais: ProfissionalComissoes[]) => void;
};

export const InclusaoEdicaoAbaProfissionais = (props: InclusaoEdicaoAbaProfissionaisProps & DadosInclusaoEdicaoAbaProfissionais) => {
  const [profissionaisSelecionados, setProfissionaisSelecionados] = useState<ProfissionalComissoes[]>(props.profissionaisSelecionados);
  const [listaProfissionaisTipo, setListaProfissionaisTipo] = useState<{[codigo: number]: string}>(props.listaProfissionaisTipo);

  const toggleProfissionaisSelecionada = (
    listarProfissionais: ProfissionalComissoes
  ) => {
    if (profissionaisSelecionados.some(p => p.Codigo == listarProfissionais.Codigo)) {
      setProfissionaisSelecionados(
        R.filter((c) => c.Codigo != listarProfissionais.Codigo, profissionaisSelecionados)
      );
    } else {
      setProfissionaisSelecionados(
        profissionaisSelecionados.concat(listarProfissionais)
      );
    }
  };

  const botaoInserirProfissional = <button
    className={clsx('no-global-button', estiloIncluirEditarAbaProfissionais.buttonIcone)}
    id="AbaProfissionais_ButtonInserir"
    onClick={() => props.onInserir(false)}>
    <FontAwesomeIcon
      className={"material-icons"}
      color="#5ac93c"
      icon={faCirclePlus}
    />{" "}Inserir
  </button>

  const botaoExcluirProfissional = <button className={clsx('no-global-button', estiloIncluirEditarAbaProfissionais.buttonIcone)}
    disabled={!(profissionaisSelecionados.length > 0)}
    onClick={() => props.onExcluir(profissionaisSelecionados)}>
    <FontAwesomeIcon
      className={"material-icons"}
      id="AbaProfissionais_ButtonExcluirIcone"
      color={profissionaisSelecionados.length > 0 ? "#f25713" : "#daddde"}
      icon={faCircleXmark}
    />{" "}Excluir
  </button>

  const botaoAplicarProfissional = <div>
    <button className={clsx('no-global-button', estiloBotoes.botaoPrimario)} 
      id="AbaProfissionais_ButtonAplicar"
    onClick={() => props.onAplicar(props.listarProfissionais)}>
      Aplicar
    </button>
  </div>

  const cabecalhoListaProfissionais = <div className="_table-header-group "
    id="AbaProfissionais_TableHeaderGroup"
  >
    <div className="_table-row"
      id="AbaProfissionais_HeaderRow"
    >
      <div className={`_table-cell _font-bold  _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>Código</div>
      <div className={`_table-cell _font-bold  _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>Nome</div>
      <div className={`_table-cell _font-bold  _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}>Tipo</div>
    </div>
  </div>

  const detalheListaProfissionais = <div className="_table-row-group"
    id="AbaProfissionais_TableRowGroup"
  >
    {props.listarProfissionais?.map((value) => (
      <div
        key={value.Codigo}
        id={`AbaProfissionais_Row${value.Codigo}`}
        className={`_table-row _cursor-pointer hover:_bg-white`}
        style={
          profissionaisSelecionados.some((p) => p.Codigo == value.Codigo)
            ? {
              backgroundColor: props.colorBackgroundSelecionadaInclusaoEdicao,
              color: props.colorTextoSelecionadaInclusaoEdicao,
            }
            : {}
        }
      >
        <div 
          className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          onClick={() => toggleProfissionaisSelecionada(value)}
          id={`AbaProfissionais_Codigo${value.Codigo}`}
        >
          {value.Codigo}
        </div>
        <div 
          className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
          onClick={() => toggleProfissionaisSelecionada(value)}
          id={`AbaProfissionais_Nome${value.Codigo}`}
        >
          {value.Nome}
        </div>
        <div className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}>
          <select 
            name="Externo"
            id={`AbaProfissionais_SelectTipo${value.Codigo}`}
            multiple={false}
            value={(listaProfissionaisTipo[value.Codigo] == undefined ? (value.Externo ? "Externo" : "Interno") : listaProfissionaisTipo[value.Codigo]) ?? ""}
            onChange={(e) => {
              const valor =
                e.target.value == "Externo"
                  ? "Externo"
                  : e.target.value == "Interno"
                  ? "Interno"
                  : "";
              const novaListaProfissionaisTipo = {
                ...listaProfissionaisTipo,
              };
              novaListaProfissionaisTipo[value.Codigo] = valor;
              setListaProfissionaisTipo(novaListaProfissionaisTipo);
            }}
          >
            <option value="Interno"
              id={`AbaProfissionais_SelectTipo${value.Codigo}_Interno`}
            >Interno</option>
            <option value="Externo"
              id={`AbaProfissionais_SelectTipo${value.Codigo}_Externo`}
            >Externo</option>
          </select>
        </div>
      </div>
    ))}
  </div>

  useEffect(() => {
    props.onAlteradoDadosInclusaoEdicaoAbaProfissionais({
      profissionaisSelecionados,
      listaProfissionaisTipo}
    );
  }, [profissionaisSelecionados, listaProfissionaisTipo]);

  return (
    <>
      <div className="_mt-8" />

      <div className={estiloIncluirEditarAbaProfissionais.buttonIconeContainer}>
        {botaoInserirProfissional}
        {botaoExcluirProfissional}
      </div>

      <div className="_p-2">
        <div className="_table _w-full _border-collapse">
          {cabecalhoListaProfissionais}
          {detalheListaProfissionais}
        </div>
      </div>

      {botaoAplicarProfissional}
    </>
  );
};
